import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import './styles.css';
import './main.css';

function KirikanGuideline() {
  return (
    <div className="body">
      <Helmet>
        <title>キリ看ちゃん二次利用・二次商用利用ガイドライン - ASMRキリスト教会</title>
        <meta
          name="description"
          content="ASMRキリスト教会のキャラクター「キリ看ちゃん」の二次利用・二次商用利用に関するガイドラインです。"
        />
      </Helmet>

      <Header subon={true} />

      <div className="container kirikan-guideline-container">
        <div className="kirikan-guideline-content">
          <img
            src={`${process.env.PUBLIC_URL}/static/images/illustration-20260803.gif`}
            alt="キリ看ちゃん"
            className="kirikan-guideline-hero"
          />
          <h1>キリ看ちゃん二次利用・二次商用利用ガイドライン</h1>

          <p>
            ASMRキリスト教会は、キャラクター「キリ看ちゃん」が、漫画、イラスト、アニメーション、ゲーム、動画、配信、グッズ制作など、さまざまな創作の中で広く親しまれ、自由に描かれ、登場することを歓迎します。
            本ガイドラインの条件を守る限り、利用者は、ASMRキリスト教会または著作者への個別連絡や個別許諾を得ることなく、キリ看ちゃんを二次利用および二次商用利用できます。
          </p>
          <p>
            基本的な考え方はシンプルです。自分で描く、作る、演出する。キリ看ちゃんであることをクレジットする。その範囲であれば、商用利用であってもロイヤリティは不要です。
          </p>
          <div className="kirikan-benefits">
            <h2>このガイドラインでできること</h2>
            <ul>
              <li>クレジット表記をすれば、個別許可なしで二次創作できます。</li>
              <li>手描き・自作の漫画、イラスト、ゲーム、動画、同人誌などは、商用利用でもロイヤリティ不要です。</li>
              <li>アクリルスタンド、フィギュア、3Dモデルなどのグッズ制作・販売もできます。</li>
              <li>宗教施設や団体の広報・イベント告知にも利用できます。</li>
            </ul>
          </div>

          <h2>1. 対象</h2>
          <p>
            本ガイドラインの対象は、ASMRキリスト教会が著作権その他必要な権利を有するキャラクター「キリ看ちゃん」の名称、キャラクター設定、外見上の特徴、およびこれらをもとに利用者が自ら制作する二次創作物です。
          </p>
          <p>
            ASMRキリスト教会が公開したイラスト、画像、動画、3Dデータ、ロゴ、文章その他の素材そのものは、別に明示する場合を除き、本ガイドラインによる自由利用の対象外です。
          </p>

          <h2>2. 許諾される利用</h2>
          <p>
            利用者は、本ガイドラインに従う限り、キリ看ちゃんを自作コンテンツに登場させ、またはキリ看ちゃんを題材にした二次創作物を制作、公開、配布、販売できます。個人、同人、商業、法人、宗教施設、教育機関など、利用者の属性は問いません。
            第5項に定めるクレジット表記を行い、社会通念上合理的な態様で利用する範囲において、利用者は、ASMRキリスト教会または著作者から事前に個別の許可を得る必要はありません。
          </p>
          <ul>
            <li>漫画、イラスト、小説、動画、アニメーション、ゲーム、配信、音声作品への登場</li>
            <li>同人誌、電子書籍、ゲーム、動画、配信コンテンツなどでの商用利用</li>
            <li>関連グッズ、アクリルスタンド、フィギュア、3Dモデル、衣装、その他物品の制作、展示、配布、販売</li>
            <li>宗教施設、教会、学校、団体その他の組織による広報、案内、イベント告知、プロモーションでの利用</li>
          </ul>

          <h2>3. 手描き・自作の場合のロイヤリティ</h2>
          <p>
            利用者が自ら描き、制作し、または手作業を中心に制作した二次創作物については、第5項に定めるクレジット表記を満たし、かつ本ガイドラインの各条件を遵守する限りにおいて、商用利用を含め、ASMRキリスト教会へのロイヤリティ支払いは不要です。売上や利益が発生しても、通常は報告の必要もありません。
          </p>
          <p>
            なお、ASMRキリスト教会が公開した公式イラスト、画像、動画、3Dデータその他の素材を、そのまま複製、転載、加工、トレース、切り抜き、再配布、商品化することはできません。キリ看ちゃんを利用する場合は、利用者自身の表現として新たに制作してください。
          </p>

          <h2>4. AIを使用する場合</h2>
          <p>
            キリ看ちゃんを題材にした二次創作物の制作に画像生成AI、動画生成AI、3D生成AI、音声生成AI、その他生成AIを実質的に使用する場合も、制作・公開・販売は可能です。この場合、利用者は、当該二次創作物から発生した月次収益の10%をASMRキリスト教会に支払うものとします。
          </p>
          <p>
            「月次収益」とは、当該二次創作物の販売、配信、広告、投げ銭、サブスクリプション、ライセンス、受託制作その他の対価として利用者が当月に受領した金額をいいます。支払方法、支払時期、算定に疑義がある場合は、利用前または収益発生後すみやかにASMRキリスト教会へ確認してください。
          </p>

          <h2>5. クレジット表記</h2>
          <p>
            二次利用または二次商用利用を行う場合、利用者は、キリ看ちゃんであることが分かるように、次のクレジットを作品内または作品説明欄、クレジット欄、商品ページ、パッケージ、展示説明その他利用態様に応じて確認しやすい場所に表示してください。
          </p>
          <p>
            <strong>キリ看ちゃん © ASMRキリスト教会 / asmrchurch.com</strong>
          </p>
          <p>
            漫画の場合は、原則としてキリ看ちゃんが登場するコマの上または下の余白、巻末、奥付、作品説明欄などに表示してください。ゲーム、3Dオブジェクト、動画、アニメーション、アプリ、配信コンテンツの場合は、クレジット欄、説明欄、エンドロール、配布ページなどに表示してください。
          </p>

          <h2>6. 宗教施設・団体によるプロモーション利用</h2>
          <p>
            宗教施設、教会、学校、団体その他の組織による広報、案内、イベント告知、プロモーションでの利用も歓迎します。この目的に限り、ASMRキリスト教会が公開した公式イラストを流用することもできます。
          </p>
          <p>
            ただし、通常のプロテスタントまたはカトリックの教義から大幅に逸脱しているとASMRキリスト教会が合理的に判断する団体、またはASMRキリスト教会、キリ看ちゃん、キリスト教信仰の信用を害する態様で利用する団体による利用は、原則としてご遠慮ください。
          </p>

          <h2>7. 禁止事項</h2>
          <p>
            多くの創作活動は歓迎されますが、次のような利用は本ガイドラインの対象外です。
          </p>
          <ul>
            <li>ASMRキリスト教会が公開した公式素材を、許可された範囲を超えて複製、転載、加工、配布、販売、商品化すること</li>
            <li>ASMRキリスト教会のイラスト、画像、動画、音声、文章、キャラクター設定、その他のコンテンツを、ASMRキリスト教会の許諾なくAI、機械学習モデル、LoRA、追加学習データ、RAGその他これらに類するシステムの学習、調整、参照用データ、生成用データとして利用すること</li>
            <li>前号の無断利用によって生成、作成、出力、または編集されたコンテンツを、ASMRキリスト教会の許諾なく発表、配布、販売、商品化、ライセンス提供し、または自己もしくは第三者の著作物・公式作品・公認作品として権利を主張すること</li>
            <li>公式作品、公式商品、公式企画、ASMRキリスト教会公認であると誤認させる表示をすること</li>
            <li>クレジット表記を行わずにキリ看ちゃんを利用すること</li>
            <li>AIを実質的に使用した二次創作物について、収益報告または10%の支払いを怠ること</li>
            <li>第三者の著作権、商標権、肖像権、名誉、プライバシーその他の権利を侵害する態様で利用すること</li>
            <li>法令または公序良俗に反する態様で利用すること</li>
            <li>ASMRキリスト教会が不適切と判断し、停止または修正を求めた後も利用を継続すること</li>
          </ul>

          <h2>8. 権利関係</h2>
          <p>
            キリ看ちゃんに関する著作権、商標権その他の権利は、ASMRキリスト教会または正当な権利者に帰属します。本ガイドラインは、条件付きの非独占的な利用許諾であり、権利の譲渡ではありません。
          </p>
          <p>
            日本の著作権法上、著作者は複製権、公衆送信権、翻案権、二次的著作物の利用に関する権利などを有します。また、著作者人格権として氏名表示権、同一性保持権などが定められています。本ガイドラインは、これらの権利に基づき、一定の条件のもとでキリ看ちゃんの利用を許諾するものです。
          </p>

          <h2>9. 違反時の取扱い</h2>
          <p>
            利用者が本ガイドラインに違反した場合、当該利用者に対する利用許諾は当然に終了します。許諾終了後の利用、または本ガイドラインの対象外の利用は、著作権侵害その他の権利侵害となる場合があります。
          </p>
          <p>
            ASMRキリスト教会は、通常、問題がある利用を確認した場合、まず利用停止、削除、修正、収益報告、未払金の支払いなど、必要な対応を求めます。悪質な利用、権利侵害、または対応がなされない場合には、損害賠償、差止め、その他法的措置を求めることがあります。
          </p>
          <p>
            特に、ASMRキリスト教会のコンテンツを無断でAI等に学習、調整、参照させ、その成果物を発表、配布、販売、商品化し、または当該成果物について著作権その他の権利を主張したことが判明した場合、ASMRキリスト教会は、著作権侵害、契約違反、不正競争その他主張可能な法的構成に基づき、訴訟その他の法的措置を検討します。
          </p>

          <h2>10. ガイドラインの変更</h2>
          <p>
            ASMRキリスト教会は、必要に応じて本ガイドラインを変更できます。変更後のガイドラインは、当サイトに掲載した時点から効力を生じます。ただし、変更前に適法に制作・販売された二次創作物については、ASMRキリスト教会が別途停止または修正を求める場合を除き、変更前の条件に基づく利用を尊重します。
          </p>

          <h2>11. お問い合わせ</h2>
          <p>
            本ガイドラインに関する確認、AI利用時の収益支払い、宗教施設・団体による利用、その他個別相談は、当サイトのお問い合わせ窓口よりご連絡ください。
          </p>

          <p style={{ marginTop: '40px', fontSize: '14px', color: '#666' }}>
            制定日：2026年8月11日<br />
            ASMRキリスト教会
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default KirikanGuideline;
